<div class="relative h-screen w-screen overflow-hidden surface-default/90 backdrop-blur-2xl">
  <!-- Close Button -->
  <button
    mat-icon-button
    (click)="dialogRef.close()"
    class="absolute right-6 top-6 z-50 !h-12 !w-12 surface-default text-gray-11 shadow-xl border border-gray-4 transition-all hover:scale-110 hover:text-gray-12 flex items-center justify-center"
  >
    <mat-icon class="!h-8 !w-8 !text-[32px] cursor-pointer">close</mat-icon>
  </button>

  <div class="flex h-full w-full">
    <!-- Main Content (Image + Nav) -->
    <div class="relative flex flex-1 flex-col items-center justify-center p-12">
      <div class="relative flex w-full max-w-5xl flex-1 items-center justify-center">
        <!-- Nav Prev -->
        <button
          (click)="prev()"
          class="group absolute left-4 z-40 flex h-14 w-14 items-center justify-center rounded-full surface-default text-gray-11 shadow-xl border border-gray-3 transition-all hover:bg-gray-2 hover:text-gray-12 sm:-left-16"
        >
          <mat-icon
            class="!h-8 !w-8 !text-[32px] transition-transform group-hover:-translate-x-0.5 cursor-pointer"
            >chevron_left</mat-icon
          >
        </button>

        <!-- Image Container -->
        <div class="relative flex h-full w-full items-center justify-center">
          @for (photo of [data.photos[currentIndex()]]; track currentIndex()) {
          <img
            animate.enter="photo-entering"
            animate.leave="photo-leaving"
            [src]="photo.url"
            class="photo-base absolute max-h-full max-w-full rounded-2xl object-contain shadow-[0_20px_50px_rgba(0,0,0,0.15)]"
            [alt]="'Photo ' + (currentIndex() + 1)"
          />
          }
        </div>

        <!-- Nav Next -->
        <button
          (click)="next()"
          class="group absolute right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full surface-default text-gray-11 shadow-xl border border-gray-3 transition-all hover:bg-gray-2 hover:text-gray-12 sm:-right-16"
        >
          <mat-icon
            class="!h-8 !w-8 !text-[32px] transition-transform group-hover:translate-x-0.5 cursor-pointer"
            >chevron_right</mat-icon
          >
        </button>
      </div>

      <!-- Info Bottom Overlay (for smaller screens) -->
      <div class="mt-8 flex flex-col items-center gap-1 text-center lg:hidden">
        <span class="text-xs font-bold uppercase tracking-widest text-brand-9">
          {{ currentIndex() + 1 }} / {{ data.photos.length }}
        </span>
        <h2 class="text-xl font-bold text-gray-12">
          {{ data.photos[currentIndex()].characteristicRef | etxeEnumDisplay: 'characteristicCategory':
          data.characteristics }}
        </h2>
      </div>
    </div>

    <!-- Right Sidebar (Thumbnails) -->
    <div class="hidden w-96 flex-col border-l border-gray-4 bg-gray-1/50 p-10 backdrop-blur-md lg:flex">
      <div class="mb-10 flex flex-col gap-3">
        <div class="flex items-center gap-2">
          <span class="text-sm font-bold uppercase tracking-widest text-brand-9"
            >{{ currentIndex() + 1 }}</span
          >
          <span class="text-sm font-medium text-gray-11">/ {{ data.photos.length }}</span>
        </div>
        <h3 class="text-2xl font-bold leading-tight text-gray-12">
          {{ data.photos[currentIndex()].characteristicRef | etxeEnumDisplay: 'characteristicCategory':
          data.characteristics }}
        </h3>
      </div>

      <div class="grid grid-cols-2 gap-4 overflow-y-auto pr-2 custom-scrollbar">
        @for (photo of data.photos; track photo.file || $index; let i = $index) {
        <button
          (click)="goTo(i)"
          class="group relative aspect-4/3 overflow-hidden rounded-xl border-2 transition-all duration-300 cursor-pointer"
          [class.border-brand-9]="currentIndex() === i"
          [class.border-transparent]="currentIndex() !== i"
          [class.opacity-60]="currentIndex() !== i"
          [class.hover:opacity-100]="currentIndex() !== i"
        >
          <img
            [src]="photo.url"
            class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
            [alt]="'Photo thumbnail ' + i"
          />
          @if (currentIndex() === i) {
          <div class="absolute inset-0 bg-brand-9/10 ring-2 ring-inset ring-brand-9"></div>
          }
        </button>
        }
      </div>
    </div>
  </div>
</div>

<style>
  /* Base state and transition */
  .photo-base {
    transition:
      opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
      transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
    transform: scale(1);
  }

  /* Enter state (Angular 21 + CSS @starting-style) */
  @starting-style {
    .photo-entering {
      opacity: 0;
      transform: scale(0.96);
    }
  }

  /* Final state for leave */
  .photo-leaving {
    opacity: 0;
    transform: scale(1.04);
  }

  .custom-scrollbar::-webkit-scrollbar {
    width: 4px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.2);
  }
</style>
